import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import React from 'react';
import Loading from '../Loading';
import Text from '../Text';
import Icon from '../Icon';
import Title from '../Title';
var iconConfig = {
  info: 'jmti-info-circle-f',
  success: 'jmti-check-circle-f',
  help: 'jmti-info-triangle-f',
  warning: 'jmti-exclamation-circle-f',
  danger: 'jmti-exclamation-circle-f'
};
export default function MessageContent(_ref) {
  var id = _ref.id,
      children = _ref.children,
      type = _ref.type,
      title = _ref.title,
      className = _ref.className;
  var loading = type === 'loading';
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: classNames('jmtd-message', className, _defineProperty({}, "jmtd-message-type-".concat(type), type))
  }, /*#__PURE__*/React.createElement("div", {
    className: "jmtd-message-content"
  }, !loading && type && /*#__PURE__*/React.createElement(Icon, {
    className: classNames('jmtd-message-icon', iconConfig[type])
  }), title && /*#__PURE__*/React.createElement(Title, {
    level: 4,
    className: "jmtd-message-title"
  }, title), loading && /*#__PURE__*/React.createElement(Loading, {
    id: "loading-9",
    className: "jmtd-message-icon jmtd-message-loading",
    loading: true,
    size: "mini"
  }), /*#__PURE__*/React.createElement("div", {
    className: "jmtd-message-text"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "regular",
    size: "regular"
  }, children))));
}
MessageContent.propTypes = {
  id: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.any,
  type: PropTypes.oneOf(['info', 'success', 'help', 'warning', 'danger', 'loading']),
  title: PropTypes.node
};
MessageContent.defaultProps = {
  id: null,
  children: null,
  className: '',
  type: null,
  title: null
};